import { Component } from '@angular/core';

@Component({
    selector: 'mobilize-info-modal',
    imports: [],
    templateUrl: './info-modal.component.html',
    styleUrl: './info-modal.component.scss'
})
export class InfoModalComponent {

}
